import { render, staticRenderFns } from "./ClMenuItem.html?vue&type=template&id=446a250c&"
import script from "./ClMenuItem.ts?vue&type=script&lang=ts&"
export * from "./ClMenuItem.ts?vue&type=script&lang=ts&"
import style0 from "./ClMenuItem.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports